// http://momentjs.cn/docs/#/use-it/
import moment from 'moment';

/**
 * get currentTime by stage
 * @param {String} stage (default: day)
 * if stage = hours, return a moment object base on current hour + 1
 * if stage = day, return a moment object base on current day 00:00:00
 */
export const getCurrentTime = ( stage ) => {

    if ( stage === 'hours' ) {

        let current = moment().add( 1, 'h' ).format( 'YYYY MM DD HH' );
        return moment( `${current}:00:00`, 'YYYY MM DD HH:mm:SS' );

    } else {

        let current = moment().format( 'YYYY MM DD' );
        return moment( `${current} 00:00:00`, 'YYYY MM DD HH:mm:SS' );

    }

};

export const timeResolve = ( time ) => {

    let times = moment( time ).format( 'YYYY Q MM ww DDD d DD HH hh A mm ss MMM MMMM Do' );
    let timeObj = times.split( ' ' );
    return {

        year: timeObj[ 0 ],
        quarter: timeObj[ 1 ],
        month: timeObj[ 2 ],
        week: timeObj[ 3 ],
        dayOfYear: timeObj[ 4 ],
        dayOfWeek: timeObj[ 5 ],
        dateOfMonth: timeObj[ 6 ],
        hour: timeObj[ 7 ],
        hourOf12Decimal: timeObj[ 8 ],
        noon: timeObj[ 9 ],
        minute: timeObj[ 10 ],
        second: timeObj[ 11 ],
        monthAbbr: timeObj[ 12 ],
        monthLong: timeObj[ 13 ],
        dateOfMonthOrder: timeObj[ 14 ]

    };

};

export const timeResolvePDT = ( time ) => {

    let times = moment.utc( time ).subtract( 7, 'h' ).format( 'YYYY Q MM ww DDD d DD HH hh A mm ss MMM MMMM Do ZZ' );
    let timeObj = times.split( ' ' );
    return {

        year: timeObj[ 0 ],
        quarter: timeObj[ 1 ],
        month: timeObj[ 2 ],
        week: timeObj[ 3 ],
        dayOfYear: timeObj[ 4 ],
        dayOfWeek: timeObj[ 5 ],
        dateOfMonth: timeObj[ 6 ],
        hour: timeObj[ 7 ],
        hourOf12Decimal: timeObj[ 8 ],
        noon: timeObj[ 9 ],
        minute: timeObj[ 10 ],
        second: timeObj[ 11 ],
        monthAbbr: timeObj[ 12 ],
        monthLong: timeObj[ 13 ],
        dateOfMonthOrder: timeObj[ 14 ]

    };

};

export const resolveToTimestamp = ({

    date,
    rangeStart,
    rangeEnd

}) => {

    let arr = date.split( '-' );
    let year = arr[ 0 ];
    let month = arr[ 1 ];
    let day = arr[ 2 ];
    let startHour = arr[ 3 ];
    let endHour = arr[ 4 ];
    let format = 'YYYY-MM-DD HH:mm:ss';
    let start = 0;
    let end = 0;
    if ( year === 'All' ) {

        start = rangeStart;
        end = rangeEnd;

    } else if ( month === 'All' ) {

        start = moment( `${year}-01-01 00:00:00`, format ).unix() * 1000;
        end = ( moment( `${year}-12-01 00:00:00`, format ).add( 1, 'y' ).unix() - 1 ) * 1000;

    } else if ( day === 'All' ) {

        start = moment( `${year}-${month}-01 00:00:00`, format ).unix() * 1000;
        end = ( moment( `${year}-${month}-01 00:00:00`, format ).add( 1, 'M' ).unix() - 1 ) * 1000;

    } else {

        start = moment( `${year}-${month}-${day} ${startHour}:00:00`, 'YYYY-MM-DD H:mm:ss' ).unix() * 1000;
        end = moment( `${year}-${month}-${day} ${endHour}:00:00`, 'YYYY-MM-DD H:mm:ss' ).unix() * 1000;

    }
    return {

        start,
        end

    };

};

export const resolveToUtc = ( timeStamp ) => {

    let str = moment( timeStamp ).format( 'YYYY-MM-DD HH:mm:ss' );
    return moment.utc( str, 'YYYY-MM-DD HH:mm:ss' ).unix() * 1000;

};

export const resolveToLocal = ( timeStamp ) => {

    let str = moment( timeStamp ).format( 'YYYY-MM-DD HH:mm:ss' );
    return moment( str, 'YYYY-MM-DD HH:mm:ss' ).unix() * 1000;

};



// WEBPACK FOOTER //
// ./src/common/js/date.js